<template>
  <div class="overlay-wrap modal">
    <div class="loadingio-spinner-spinner-acmdkw9v8mu"><div class="ldio-xysc4s9ys08">
<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
</div></div>
  </div>

</template>

<style lang="scss" scoped>
.loadingBar{
  width: 100%;
  height: 10px;
  border-radius: 10px;
}

</style>
